import { useEffect, useState } from "react";

// Toont pas een laadstatus als het laden langer duurt dan `delay` ms,
// zodat snelle navigaties nooit een "Loading"-flits laten zien.
export function useDelayedLoading(isLoading: boolean, delay = 200) {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setShowLoading(false);
      return;
    }
    const timeout = setTimeout(() => setShowLoading(true), delay);
    return () => clearTimeout(timeout);
  }, [isLoading, delay]);

  return showLoading;
}
